import { IdentityDocuments } from "./identity-documents";

export function GovPass() {
  return <IdentityDocuments />;
}
